import { LOCAL_STORAGE_KEYS } from '@/constants/constants';

export const generateAuthHeaders = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSION_TOKEN);
  return token ? { sessionToken: token } : {};
};
